const map = {
	"./avisos.json": 25546,
	"./backend-servicios.json": 27909,
	"./backend.json": 26105,
	"i18n/locales/es/avisos.json": 25546,
	"i18n/locales/es/backend-servicios.json": 27909,
	"i18n/locales/es/backend.json": 26105
};


function webpackContext(req) {
	const id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		const e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 27246;